export default "__VITE_ASSET__BKv76rrx__"